import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';

@Component({
    selector: 'app-logout',
    templateUrl: './logout.component.html',
    styleUrls: ['./logout.component.css'],
    standalone: false
})
export class LogoutComponent implements OnInit {

  constructor(private auth: AuthService,
              private router: Router) { }

  ngOnInit(): void {
  }

  salir(){

    this.auth.logOut()
    .subscribe(resp => {
      // this.router.navigate(['**']);
      window.location.reload();
      console.log(resp);
    }
    , (err) => {
      console.log(err);
    });

  }

}
